/** UI-only labels: OGCL transfer requests are shown as ITCL requests for branch users. */

export const ITCL_REQUEST_TITLE = 'ITCL Requests';
export const ITCL_REQUEST_CREATE = 'Create ITCL Request';
export const ITCL_REQUEST_SUBTITLE =
  'ITCL hub transfers awaiting review — approved requests are unloaded and dispatched at the destination hub';
export const ITCL_REQUEST_CREATED = 'ITCL request created';
export const ITCL_REQUEST_LOAD_ERROR = 'Failed to load ITCL requests';
export const ITCL_REQUEST_DETAIL_ERROR = 'Failed to load ITCL request';
